import { Box, Button, Typography } from "@mui/material";
import React from "react";
import SubHeader from "../../../../components/SubHeader";
import color from "../../../../constants/color";
import style from "./style";
import { useNavigate } from "react-router-dom";
import IncomeList from "./IncomeList";

const OtherIncomePage = ({data,deleteOtherIncome,page,setPage,setTotalCount,totalCount}) => {
  const navigate = useNavigate()
  return(
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.heading}>Other Income List</Typography>

        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
          <Button variant="contained" color="success" sx={style.checkinBtn} onClick={() =>navigate("/dashboard/addOtherIncome")}>
            {"+ Add Other Income"}
          </Button>

        </Box>
      </Box>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          isShow={false}
          search
          sortBy/>
      
        <IncomeList deleteOtherIncome={deleteOtherIncome} page={page} setPage={setPage} totalCount={totalCount} setTotalCount={setTotalCount} data={data} />

      </Box></>
  )
}

export default OtherIncomePage